import React, { useState } from 'react'

import { StreamingNotesFilters } from './Filters'
import { Thread } from './Thread'
import { MessageComposerDnD } from './components/MessageComposerDnD'
import { useCurrentApplication } from '@/graphql/services/application'
import { useCreateStreamingNoteMutation } from '@/services/streamingNote'

export function StreamingNotes() {
  const {
    data: application,
    isLoading: isLoadingApplication,
    isFetching: isFetchingApplication,
  } = useCurrentApplication()

  const [createStreamingNote, { isLoading: isCreatingStreamingNote }] =
    useCreateStreamingNoteMutation()

  const [selectedUser, setSelectedUser] = useState(null)

  const handleSelectUser = (selectedUser) => {
    setSelectedUser(selectedUser?.value)
  }

  return (
    <div className='absolute inset-0 top-[90px] flex flex-col gap-1 px-3 mb-1'>
      <StreamingNotesFilters onSelectUser={handleSelectUser} />
      <Thread
        key={application?.externalId}
        application={application}
        isLoadingApplication={isLoadingApplication}
        isFetchingApplication={isFetchingApplication}
        selectedUser={selectedUser}
      />
      <MessageComposerDnD
        applicationExternalId={application?.externalId}
        applicationId={application?.id}
        createStreamingNote={createStreamingNote}
        isCreatingStreamingNote={isCreatingStreamingNote}
      />
    </div>
  )
}
